export default {
  cookieConsent: {
    ariaLabel: "Aviso de cookies",
    title: "Tu privacidad, en serio",
    bodyPre: "HelixScan solo usa almacenamiento ",
    bodyEssential: "esencial",
    bodyMid: " en tu navegador (mantener tu sesión y recordar tus preferencias). ",
    bodyNoAds: "No usamos cookies de publicidad",
    bodyPost: " ni, a día de hoy, de analítica. Si algún día añadimos medición de uso, solo se activará si la aceptas aquí. ",
    policyLink: "Política de cookies",
    essentialOnly: "Solo esenciales",
    acceptAll: "Aceptar todo",
  },
};
